import { render } from "./OrDivider.vue?vue&type=template&id=067cf1d9&scoped=true"
const script = {}

import "./OrDivider.vue?vue&type=style&index=0&id=067cf1d9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067cf1d9"]])

export default __exports__